"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Renderables_1 = require("../../Renderables");
var BaseInput_1 = require("../BaseInput");
/**
 * Implementation of the 'phone' markup element.
 * An input HTML element is created and the given attributes name and
 * value are taken over from the markup. The class lto-phone is added
 * to allow CSS manipulations and a change listener is added.
 *
 * @see {@link IRenderable}
 */
var Phone = /** @class */ (function (_super) {
    __extends(Phone, _super);
    function Phone(spec) {
        return _super.call(this, spec) || this;
    }
    /**
     * @inheritDoc
     */
    Phone.prototype.render = function (renderer, isNested) {
        return this.initInput("tel", "lto-phone", isNested);
    };
    return Phone;
}(BaseInput_1.BaseInput));
exports.Phone = Phone;
Renderables_1.default.register("phone", Phone);
